import { storeInstance } from 'redux/store'
import { showAlert } from 'redux/slices/Alert'
import i18n from 'i18n'

export const handleStatus500 = (
  error: any,
  message?: string,
  type?: string,
) => {
  const status = error?.status || error?.response?.status
  const isTA = type === 'TA'

  if (`${status}`.startsWith('50')) {
    const errorTitle = i18n.t('alert.error.50x')
    storeInstance?.dispatch((dispatch) => {
      dispatch(showAlert({ title: errorTitle, message }))
    })
    return error
  }

  const dispatchAlert = (key: string) => {
    const title = `${key}: ${i18n.t('common.error')}`
    storeInstance?.dispatch(showAlert({ title, message }))
  }

  if (isTA) {
    switch (status) {
      case 422:
        dispatchAlert(status)
        break
      case 403:
        dispatchAlert(status)
        break
      case 404:
        dispatchAlert(status)
        break
      case 401:
        dispatchAlert(status)
        break
    }

    // Handle CORS
    if (!status && error?.message?.includes('Network Error')) {
      dispatchAlert('CORS')
    }
  }

  return error
}
